import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomMenu from '../components/BottomMenu/BottomMenu';
import { SecurityWarningPopup } from '../components/common/Popup';

const SECURITY_WARNING_FLAG = 'showSecurityWarningAfterLogin';

const BottomMenuLayout: React.FC = () => {
  const location = useLocation();
  const [securityWarningVisible, setSecurityWarningVisible] = useState(false);

  useEffect(() => {
    // Clear history and prevent browser back button
    window.history.pushState(null, '', location.pathname);
    window.onpopstate = () => {
      window.history.pushState(null, '', location.pathname);
    };

    // Cleanup function to remove the popstate event listener
    return () => {
      window.onpopstate = null;
    };
  }, [location.pathname]);

  useEffect(() => {
    if (sessionStorage.getItem(SECURITY_WARNING_FLAG) === 'true') {
      setSecurityWarningVisible(true);
    }
  }, []);

  const handleCloseSecurityWarning = () => {
    sessionStorage.removeItem(SECURITY_WARNING_FLAG);
    setSecurityWarningVisible(false);
  };

  return (
    <div className="flex flex-col h-screen w-full bg-white overflow-hidden">
      {/* Main content area - allowing children to control overflow */}
      <div
        className="flex-1 overflow-y-auto"
        style={{
          WebkitOverflowScrolling: 'auto',
          overscrollBehaviorY: 'contain',
        }}
      >
        <Outlet />
      </div>
      {/* Fixed bottom menu with higher z-index */}
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <BottomMenu />
      </div>

      <SecurityWarningPopup
        visible={securityWarningVisible}
        onClose={handleCloseSecurityWarning}
      />
    </div>
  );
};

export default BottomMenuLayout;
